import { PurchaseorderService } from './../../../services/purchaseorder.service';
import { Component, Input, OnInit } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { gridPageRequest, StoreConsumptionGridResponse } from '../../../model/common/common.model';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import _ from 'lodash';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SalesService } from '../../../services/sales.service';
import { InventoryService } from '../../../services/inventory.service';
import { AdministratorService } from '../../../services/administrator.service';
import { Warehouse } from '../../../model/administration.model';
import { setCurrentTimeOnDates } from '../../../services/utils/date-utils';


@Component({
  selector: 'app-store-consumption-lookup',
  standalone: true,
  imports: [SharedModule, CommonModule, AutoCompleteModule],
  templateUrl: './store-consumption-lookup.component.html',
  styleUrl: './store-consumption-lookup.component.scss'
})
export class StoreConsumptionLookupComponent implements OnInit {


  filteredProducts: any[] = [];
  products: [] = [];
  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 100,
    id: 0
  }


  submitted: any;
  isEdit: boolean = false;
  isEditMode: boolean = false;
  isEditModeComponent: boolean = false;
  loader: boolean = false;
  nonInventryProductList: any[] = [];
  visible: boolean = false;
  selectedProduct: any[] = [];
  lineItemData: any[] = [];
  ProjectManufacturingBatchID: any;
  saveData: any;
  refStoreConsumptionLine: DynamicDialogRef | undefined;
  refStoreConsumption: DynamicDialogRef | undefined;
  SaveDataLineitem: any;
  storeconsumptionData: any[] = [];
  storeConsumptionId: any;
  isEditModesc: boolean = false;
  saveDataLineItem: any;
  warehouseDropdown: any[] = [];
  filtewarehouse: Warehouse[] = [];
  deleteProductIds: any[] = [];
  warehouseId: any;
  quantityAvail: any;

  constructor(private messageService: MessageService, private fb: FormBuilder, public ref: DynamicDialogRef, private purchaseorderService: PurchaseorderService, private salesService: SalesService, public dialogService: DialogService,
    private config: DynamicDialogConfig, private inventoryService: InventoryService, private administratorService: AdministratorService, private confirmationService: ConfirmationService
  ) {
  }


  ngOnInit(): void {
    const todayDate = new Date();
    this.storeConsumptionForm.controls['createdDate'].setValue(todayDate);
    this.storeConsumptionForm.controls['createdBy'].setValue(localStorage.getItem('username'));

    // Call once initially
    // this.manualEntry2();

    // // Subscribe to checkbox change
    // this.storeConsumptionLineitemForm.get('manualEntry2')?.valueChanges.subscribe(value => {
    //   this.manualEntry2();
    // });

    this.ProjectManufacturingBatchID = this.config.data?.ProjectManufacturingBatchID;
    this.warehouseId = this.config.data?.warehouseId;

    const mode = this.config.data?.mode;
    if (mode === 'edit' && this.config.data?.storeconsumptionLineItemData) {
      this.isEditModeComponent = true;
      this.isEdit = true;
      this.editStoreConsumption();
    } else {
      this.isEditModeComponent = false;
      this.isEdit = false;
      this.manualEntry();
      this.getserialNumber();

    }

    this.storeConsumptionForm.controls['fromDate'].valueChanges.subscribe(() => this.onDateChange());
    this.storeConsumptionForm.controls['endDate'].valueChanges.subscribe(() => this.onDateChange());
    this.storeConsumptionForm.controls['laborRate'].valueChanges.subscribe(() => this.calculateTotLaborCost());

    this.storeConsumptionLineitemForm.controls['rate'].valueChanges.subscribe(() => {
      this.calculateTotalCost();
    });

    this.storeConsumptionLineitemForm.controls['consumedQty'].valueChanges.subscribe(() => {
      this.calculateTotalCost();
    });

    this.storeConsumptionLineitemForm.controls['openingInventory'].valueChanges.subscribe(() => {
      this.calculateTotalCost();
    });
  }


  storeConsumptionForm = new FormGroup({
    storeConsumptionId: new FormControl(0),
    ProjectManufacturingBatchID: new FormControl(0),
    empName: new FormControl(),
    fromDate: new FormControl(),
    scCode: new FormControl(),
    endDate: new FormControl(),
    manualEntry: new FormControl(false),
    totDays: new FormControl(),
    laborRate: new FormControl(),
    totLaborCost: new FormControl(),
    IsActive: new FormControl(true),
    createdDate: new FormControl(),
    createdBy: new FormControl(),
    updatedBy: new FormControl(),
    updatedDate: new FormControl,
  })


  storeConsumptionLineitemForm = new FormGroup({
    storeConsumptionlineItemId: new FormControl(0),
    storeConsumptionId: new FormControl(0),
    productCode: new FormControl('', Validators.required),
    description: new FormControl(),
    serialNumber: new FormControl('', Validators.required),
    // requiredQty: new FormControl(Validators.required),
    consumedQty: new FormControl(),
    openingInventory: new FormControl(),
    closingInventory: new FormControl(),
    totCost: new FormControl(),
    consumedInOperation: new FormControl(),
    rate: new FormControl(),
    manualEntry2: new FormControl(false),
    IsActive: new FormControl(true),
    createdDate: new FormControl(),
    createdBy: new FormControl(),
    updatedBy: new FormControl(),
    updatedDate: new FormControl(),
    quantityAvail: new FormControl(),
    date: new FormControl(),

  })


  result: StoreConsumptionGridResponse = {
    storeConsumption: [],
    totalRecords: 0
  }


  get formControls() {
    return this.storeConsumptionForm.controls;
  }

  get formControl() {
    return this.storeConsumptionLineitemForm.controls;
  }

  get totalConsumedQty(): number {
    return this.storeconsumptionData?.reduce((sum, item) => sum + (item.consumedQty || 0), 0) || 0;
  }

  get totalCost(): number {
    return this.storeconsumptionData?.reduce((sum, item) => sum + (item.totCost || 0), 0) || 0;
  }

  onDateChange() {
    const fromDate = this.storeConsumptionForm.controls['fromDate'].value;
    const endDate = this.storeConsumptionForm.controls['endDate'].value;

    if (fromDate && endDate) {
      if (new Date(fromDate) > new Date(endDate)) {
        this.messageService.add({
          severity: 'error',
          summary: 'Invalid Date Range',
          detail: 'End Date cannot be earlier than Start Date.'
        });
        this.storeConsumptionForm.controls['totDays'].setValue(null);
        this.storeConsumptionForm.controls['totLaborCost'].setValue(null);
        return;
      }

      const diffTime = Math.abs(new Date(endDate).getTime() - new Date(fromDate).getTime());
      const totDays = Math.ceil(diffTime / (1000 * 3600 * 24));
      this.storeConsumptionForm.controls['totDays'].setValue(totDays);

      this.calculateTotLaborCost();
    }
  }


  calculateTotLaborCost() {
    const totDays = this.storeConsumptionForm.controls['totDays'].value;
    const laborRate = this.storeConsumptionForm.controls['laborRate'].value;

    if (totDays && laborRate) {
      const totLaborCost = totDays * laborRate;
      this.storeConsumptionForm.controls['totLaborCost'].setValue(totLaborCost);
    }
  }

  CreateStoreConsumption(data: any) {
    this.submitted = true;

    if (this.isEditModeComponent) {
      this.ref.close({
        saveData: data,
        SaveDataLineitem: this.storeconsumptionData
      });

      const newItems = this.storeconsumptionData.filter(item => item.storeConsumptionId === null);
      newItems.forEach(item => {
        item.storeConsumptionId = data.storeConsumptionId;
      });

      if (newItems.length > 0) {
        this.createStoreConsumptionLineItem(newItems);
      }

      this.purchaseorderService.deleteStoreConsumptionLineItem(this.deleteProductIds).subscribe({});

      setTimeout(() => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Store Consumption Updated Successfully.'
        });
      }, 0);
    }

    const requiredFields = ['scCode', 'empName', 'totDays', 'endDate', 'fromDate'];
    for (const field of requiredFields) {
      if (!data[field]) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Validation Error',
          detail: `${field} is required.`
        });
        return;
      }
    }

    if (!this.isEditModeComponent) {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Store Consumption Save Successfully.'
      });
    }

    data.IsActive = true;
    const currentTime = new Date();
    data.fromDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
    data.endDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());

    this.purchaseorderService.CreateStoreConsumption(data).subscribe({
      next: (response: any) => {
        this.saveData = data;
        const existingStoreConsumptionId = response.id;
        this.saveData.storeConsumptionId = existingStoreConsumptionId;

        const newItems = this.storeconsumptionData.filter(item => item.storeConsumptionId === null);
        newItems.forEach(item => {
          item.storeConsumptionId = existingStoreConsumptionId;
        });

        if (newItems.length > 0) {
          this.createStoreConsumptionLineItem(newItems);
        }
      },
      error: (error) => {
        console.error('Error saving store consumption:', error);
      },
      complete: () => {
        this.ref.close({
          saveData: this.saveData,
          SaveDataLineitem: this.storeconsumptionData
        });
      }
    });
  }

  createStoreConsumptionLineItem(data: any[]) {
    if (Array.isArray(data) && data.length > 0) {
      setCurrentTimeOnDates(data);
      data.forEach(item => {
        if (item.storeConsumptionlineItemId === null || item.storeConsumptionlineItemId === undefined) {
          item.storeConsumptionlineItemId = 0;
        }

        if (item.IsActive === null || item.IsActive === undefined) {
          item.IsActive = true;
        }
      });

      this.purchaseorderService.CreateStoreConsumptionLineItem(data).subscribe({
        next: (response: any) => {
          // handle success if needed
        },
        error: error => {
          console.error('Error saving store consumption line items:', error);
        }
      });
    }
  }

  cancel(data: any) {
    this.ref.close();
    this.selectedProduct = [];
  }


  checkSCNumber() {
    if (!this.storeConsumptionForm.controls.scCode.value) {
      return;
    }
    if (this.products.length > 0) {
      return;
    }
    if (!this.isEdit) {
      this.purchaseorderService.checkSCNumber(this.storeConsumptionForm.controls.scCode.value).subscribe(
        (data: any) => {
          if (data.success == true) {
            // console.log(data);
          } else {
            this.storeConsumptionForm.controls.manualEntry.setValue(true);
          }
        },
        (error: any) => {
          console.log(error);
        }
      );
    }
  }

  manualEntry() {
    const manualEntryValue = this.storeConsumptionForm.controls.manualEntry.value;

    if (manualEntryValue === true) {
      this.storeConsumptionForm.controls.scCode.setValue('');
    } else {
      this.getProductCode();
    }
  }

  getProductCode() {
    this.loader = true;
    this.purchaseorderService.autogenerateSCNumber().subscribe({
      next: (data: any) => {
        // const alphanumericCode = 'SC';
        // const order = alphanumericCode + data;
        //this.storeConsumptionForm.controls.scCode.setValue(_.toString(order));
        this.storeConsumptionForm.controls.scCode.setValue(data.fullNumber);
        this.loader = false;
      },
      error: error => {
        console.log(error);
        this.loader = false;
      }
    });
  }


  editStoreConsumption() {
    this.isEditModeComponent = true;
    let data = this.config.data?.storeconsumptionLineItemData;

    if (data === undefined) {
      this.isEditModeComponent = false;
      this.isEdit = false;
    } else {
      this.isEditModeComponent = true;
      this.isEdit = true;
    }

    const fromDate = data?.fromDate ? new Date(data.fromDate) : null;
    const endDate = data?.endDate ? new Date(data.endDate) : null;

    if (data) {
      this.storeConsumptionForm.patchValue({
        storeConsumptionId: data.storeConsumptionId,
        ProjectManufacturingBatchID: data.projectManufacturingBatchID,
        empName: data.empName,
        fromDate: fromDate,
        endDate: endDate,
        scCode: data.scCode,
        totDays: data.totDays,
        laborRate: data.laborRate,
        totLaborCost: data.totLaborCost
      });

      this.storeConsumptionId = data.storeConsumptionId;
      this.getStoreConsumptionLineItem(data.storeConsumptionId);

    }
  }


  getStoreConsumptionLineItem(storeConsumptionId: any) {
    this.loader = true;

    this.purchaseorderService.getStoreConsumptionlineitemByScId(storeConsumptionId).subscribe(
      (data: any) => {
        this.storeconsumptionData = data;

        if (this.config.data?.SaveDataLineitem) {
          this.storeconsumptionData = this.storeconsumptionData.map(item => {
            const updatedItem = this.config.data?.SaveDataLineitem.find((d: { storeConsumptionlineItemId: any; }) => d.storeConsumptionlineItemId === item.storeConsumptionlineItemId);
            return updatedItem ? { ...item, ...updatedItem } : item;
          });
        }

        this.loader = false;
      },
      (error: any) => {
        console.error('Error fetching store consumption line items:', error);
        this.loader = false;
      }
    );
  }

  validateForm() {
    let isValid = true;
    if (this.storeConsumptionForm.invalid) {
      isValid = false;
    }

    return isValid;
  }

  // line items ..............................................................................................................................


  CreateStoreConsumptionLineitem(data: any) {
    this.submitted = true;

    const requiredFields = ['serialNumber', 'productCode', 'consumedQty', 'date'];
    for (const field of requiredFields) {
      if (data[field] === null || data[field] === undefined || data[field] === '') {
        this.messageService.add({
          severity: 'warn',
          summary: 'Validation Error',
          detail: `${field} is required.`
        });
        return;
      }
    }

    if (this.isEditModesc) {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Store Consumption Line Item Updated Successfully.'
      });

      const index = this.storeconsumptionData.findIndex(item => item.serialNumber === data.serialNumber);
      if (index !== -1) {
        this.storeconsumptionData[index] = data;
      }

    } else {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Store Consumption Line Item Created Successfully.'
      });

      this.storeconsumptionData.push(data);
    }

    this.visible = false;
    this.selectedProduct = [];
  }

  checkMONumber() {
    if (!this.storeConsumptionLineitemForm.controls.serialNumber.value) {
      return;
    }
    if (this.products.length > 0) {
      return;
    }
    if (!this.isEdit) {
      this.purchaseorderService.checkMONumber(this.storeConsumptionLineitemForm.controls.serialNumber.value).subscribe(
        (data: any) => {
          if (data.success == true) {
            // console.log(data);
          } else {
            this.storeConsumptionLineitemForm.controls.manualEntry2.setValue(true);
          }
        },
        (error: any) => {
          console.log(error);
        }
      );
    }
  }

  // manualEntry2() {
  //   const manualEntryValue = this.storeConsumptionLineitemForm.controls.manualEntry2.value;

  //   if (manualEntryValue === true) {
  //     this.storeConsumptionLineitemForm.controls.serialNumber.setValue('');
  //   } else {
  //     this.getOrderNumber();
  //   }
  // }

  manualEntry2() {
    const manualEntryValue = this.storeConsumptionLineitemForm.get('manualEntry2')?.value;

    if (manualEntryValue) {
      this.storeConsumptionLineitemForm.get('serialNumber')?.setValue('');
    } else {
      // this.getOrderNumber();
      this.getserialNumber();
    }
  }

  getOrderNumber() {
    this.loader = true;
    this.purchaseorderService.autogenerateSCLNumber().subscribe({
      next: (data: any) => {
        const alphanumericCode = 'SC';
        const order = alphanumericCode + data;
        // this.storeConsumptionLineitemForm.controls.serialNumber.setValue(_.toString(order));
        this.storeConsumptionLineitemForm.controls.serialNumber.setValue(data.fullNumber);

        this.loader = false;
      },
      error: error => {
        console.log(error);
        this.loader = false;
      }
    });
  }
  // getserialNumber() {
  //   this.loader = true;
  //   this.purchaseorderService.autogenerateSCLNumber().subscribe({
  //     next: (data: any) => {
  //       console.log(data);

  //       const alphanumericCode = 'SC';
  //       const order = alphanumericCode + data;
  //       this.storeConsumptionLineitemForm.controls.serialNumber.setValue(_.toString(order));
  //       //this.storeConsumptionLineitemForm.controls.serialNumber.setValue(data);
  //       this.loader = false;
  //     },
  //     error: error => {
  //       //console.log(error);
  //       this.loader = false;
  //     }
  //   });
  // }

  getserialNumber() {
    this.loader = true;

    this.purchaseorderService.autogenerateSCLNumber().subscribe({
      next: (data: any) => {

        const alphanumericCode = 'SC';
        const order = alphanumericCode + data;
        this.storeConsumptionLineitemForm.controls['serialNumber'].setValue(_.toString(order) as any);

        // this.storeConsumptionLineitemForm.patchValue({
        //   serialNumber: data.serialNumber
        // });

        this.loader = false;
      },
      error: error => {
        console.log(error);
        this.loader = false;
      }
    });
  }


  addNewItem() {
    this.selectedProduct = [];
    this.showDialog();
  }

  editItem() {
    if (this.selectedProduct && this.selectedProduct.length === 1) {
      this.editStoreConsumptionLineitem(this.selectedProduct[0]);
    }
  }



  showDialog() {
    this.visible = true;
    this.isEditModesc = false;
    this.resetForm();
    //this.getOrderNumber();
    this.getserialNumber();
  }

  resetForm() {
    this.storeConsumptionLineitemForm.reset();
    this.submitted = false;
    this.isEditModesc = false;
  }


  cancels(data: any) {
    this.visible = false;
    this.resetForm();
    this.selectedProduct = [];
  }


  editStoreConsumptionLineitem(data: any) {
    this.isEditModesc = true;
    const SPDate = data?.date ? new Date(data.date) : null;
    this.storeConsumptionLineitemForm.patchValue({
      storeConsumptionId: data.storeConsumptionId,
      storeConsumptionlineItemId: data.storeConsumptionlineItemId,
      serialNumber: data.serialNumber,
      rate: data.rate,
      productCode: data.productCode,
      consumedQty: data.consumedQty,
      openingInventory: data.openingInventory,
      closingInventory: data.closingInventory,
      consumedInOperation: data.consumedInOperation,
      totCost: data.totCost,
      description: data.description,
      date: SPDate
    });
    this.getInventoryStatus(data.productCode.split(" ")[0]);
    this.visible = true;
  }

  autoSearchNonInventryProducts(event: any) {
    this.salesService.autoSearchProduct(event.query).subscribe(
      (data: any[]) => {
        // if (data) {
        //     this.nonInventryProductList = data.filter(product => product.isInventory === false);
        // } else {
        this.nonInventryProductList = data;
        // }
      },
      (error: any) => {
        console.error('Error fetching products:', error);
      }
    );
  }


  setProducts(data: any) {
    const productCode = data.value.productCode;
    const productName = data.value.productName;
    const Rate = data.value.salesPrice;
    this.storeConsumptionLineitemForm.controls.rate.setValue(Rate);
    const productDisplay = `${productCode} - ${productName}`;
    this.storeConsumptionLineitemForm.controls.productCode.setValue(productDisplay);
    this.getInventoryStatus(data.value.productCode);

  }

  getInventoryStatus(productCode: string) {
    this.inventoryService.getInventoryStatus(productCode).subscribe({
      next: (data: any) => {
        if (data.success === false) {
        } else {
          const inventoryItem = data.find((item: { warehouseId: any; }) => item.warehouseId === this.warehouseId);
          if (inventoryItem) {
            this.storeConsumptionLineitemForm.controls.quantityAvail.setValue(inventoryItem.quantityAvailable);
          } else {
            console.log(`No inventory item found for warehouse ID: ${this.warehouseId}`);
          }
        }
      },
      error: error => {
        console.log(error);
      }
    });
  }


  calculateTotalCost() {
    const rate = Number(this.storeConsumptionLineitemForm.controls['rate'].value);
    const qty = Number(this.storeConsumptionLineitemForm.controls['consumedQty'].value);
    const openingInventory = Number(this.storeConsumptionLineitemForm.controls['openingInventory'].value);

    const totalCost = rate * qty;
    this.storeConsumptionLineitemForm.controls['totCost'].setValue(isNaN(totalCost) ? 0 : totalCost);

    const closingInventory = openingInventory - qty;
    this.storeConsumptionLineitemForm.controls['closingInventory'].setValue(isNaN(closingInventory) ? 0 : closingInventory);
  }

  deleteSClineItems() {
    if (!this.selectedProduct || this.selectedProduct.length === 0) {
      return;
    }

    this.confirmationService.confirm({
      header: 'Are you sure?',
      message: 'Please confirm to proceed.',
      accept: () => {
        this.loader = true;
        let selectedProductIds = this.selectedProduct.map(product => product.storeConsumptionlineItemId);

        this.removeLineItems(selectedProductIds);
        this.selectedProduct = [];

        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Store Consumption Line Item Deleted successfully.' });
        this.loader = false;

      },
      reject: () => {
      }
    });
  }



  removeLineItems(selectedProductIds: any) {
    for (let id of selectedProductIds) {
      this.deleteProductIds = selectedProductIds;
      const index = this.storeconsumptionData.findIndex(item => item.storeConsumptionlineItemId === id);
      if (index !== -1) {
        this.storeconsumptionData.splice(index, 1);
      }
    }
  }

}
